import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { formatDate, formatMonthReponse, formatNumberSpacing, formatWeekResponse } from 'src/constants';

// Register necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const LineChart = ({ data, label, labelKey, xLabel, yLabel, color, pointColor }) => {
  const labels = data?.map((item) =>
    labelKey === 'date'
      ? formatDate(item[labelKey])
      : labelKey === 'week'
        ? formatWeekResponse(item[labelKey])
        : labelKey === 'month'
          ? formatMonthReponse(item[labelKey])
          : item[labelKey]
  );

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: label,
        data: data?.map((item) => item.revenue),
        borderColor: color || '#36A2EB',
        backgroundColor: pointColor || '#FF6384',
        pointBorderColor: pointColor || '#FF6384',
        pointBackgroundColor: pointColor || '#FF6384',
        fill: false,
        borderWidth: 2,
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: $${formatNumberSpacing(context.raw)}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xLabel,
          font: {
            size: 14,
          },
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        title: {
          display: true,
          text: yLabel,
          font: {
            size: 14,
          },
        },
        grid: {
          drawBorder: false,
          color: '#EAEAEA',
        },
        ticks: {
          beginAtZero: true,
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default LineChart;
